// Tools on /tools, shared by frontend/src/views/PublicToolsHub.vue and middleware.js.
export const TOOLS_HUB = {
  title: 'Tools for Instagram Reels and TikTok | VideoDatabase',
  description: 'Check a Reel’s size, aspect ratio, length and safe zone before you post, free in your browser. Plus Instagram and TikTok transcript generators from Content Tools.',
  h1: 'Tools for Reels and TikTok',
  lede: 'Free checks to run before you hit post.',
  sisterHeading: 'From Content Tools, our sister app',
};

export const TOOLS = [
  {
    slug: 'instagram-reels-size',
    name: 'Instagram Reels size checker',
    line: 'Find out if your Reel fills the screen, is short enough to be recommended to new viewers and keeps its text clear of the buttons.',
  },
];

// Colin's sister app (NY-25: "Linking would def be good").
export const SISTER_TOOLS = [
  { name: 'Instagram transcript generator', href: 'https://contenttools.ai/instagram-transcript-generator' },
  { name: 'TikTok transcript generator', href: 'https://contenttools.ai/tiktok-transcript-generator' },
];
